import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Modal } from 'antd';

const DeleteOrganizationConfirmationModal: FC<{
  onOk: () => void;
  onClose: () => void;
  organizationName: string;
}> = ({ onClose, onOk, organizationName }) => {
  const { t } = useTranslation();
  const [userType, setUserType] = useState<string>('');

  return (
    <Modal
      className="figma-modal"
      title={<h3 className="figma-modal__title">{t('DeleteOrganization')}</h3>}
      open={true}
      onOk={() => userType === organizationName && onOk()}
      onCancel={onClose}
      okButtonProps={{ disabled: userType !== organizationName, style: { width: '45%', float: 'right' } }}
      cancelButtonProps={{ type: 'default', style: { width: '45%' } }}
      okText={t('Confirm')}
      cancelText={t('Cancel')}
    >
      <Form layout="vertical" autoComplete="off">
        <Form.Item label={t('TypeOrganizationNameToConfirm')}>
          <Input value={userType} onChange={(e) => setUserType(e.target.value)} />
          <small>
            {t('Type')}: <strong>{organizationName}</strong>
          </small>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DeleteOrganizationConfirmationModal;
